const carouselItems = [
  {
    id: 1,
    title: '网红翻车实录',
    subtitle: '从人设天花板到全网封杀的灰色48小时',
    desc: '深度复盘近期多位大网红翻车的完整时间线，剖析人设崩塌背后的共同规律与教训。',
    src: 'https://readdy.ai/api/search-image?query=wide%20abstract%20panoramic%20warm%20coral%20red%20and%20gold%20flowing%20across%20dark%20canvas%20cinematic%20atmosphere%20dramatic%20lighting%20editorial%20quality%20modern%20artistic%20style&width=1400&height=800&seq=carousel-01&orientation=landscape',
  },
  {
    id: 2,
    title: '综艺争议大盘点',
    subtitle: '那些被剧本和剪辑毁掉的真相比想象中更残酷',
    desc: '从选秀黑幕到真人秀剧本造假，揭露综艺行业最不愿被提及的阴暗角落。',
    src: 'https://readdy.ai/api/search-image?query=panoramic%20abstract%20composition%20warm%20amber%20waves%20dark%20backdrop%20elegant%20editorial%20style%20sophisticated%20mood%20cinematic%20atmosphere%20professional%20quality&width=1400&height=800&seq=carousel-02&orientation=landscape',
  },
  {
    id: 3,
    title: '品牌塌房全记录',
    subtitle: '当信任崩塌：消费者维权背后的品牌信任危机',
    desc: '整理近一年最受关注的品牌翻车事件，从产品质量到虚假宣传，消费者该如何保护自己。',
    src: 'https://readdy.ai/api/search-image?query=wide%20cinematic%20abstract%20scene%20warm%20coral%20and%20deep%20red%20gradient%20dark%20background%20atmospheric%20glow%20modern%20digital%20art%20dramatic%20professional&width=1400&height=800&seq=carousel-03&orientation=landscape',
  },
  {
    id: 4,
    title: '素人爆料精选集',
    subtitle: '平凡人的不平凡声音：那些改变舆论格局的真实爆料',
    desc: '每一个素人爆料都可能成为撬动舆论的支点，盘点最具影响力的素人爆料合集。',
    src: 'https://readdy.ai/api/search-image?query=panoramic%20artistic%20abstract%20warm%20golden%20light%20rays%20dark%20canvas%20modern%20digital%20art%20impressive%20scale%20editorial%20quality%20dramatic%20atmosphere&width=1400&height=800&seq=carousel-04&orientation=landscape',
  },
];

export default function SectionCarousel() {
  return (
    <section id="carousel" className="w-full py-16 md:py-20 bg-background-100">
      <div className="w-full px-6 md:px-10">
        <div className="max-w-[1200px] mx-auto">
          <div className="text-center mb-10">
            <span className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full text-xs font-medium bg-accent-100 text-accent-700 mb-4 whitespace-nowrap">
              <i className="ri-focus-2-line"></i> 深度聚焦
            </span>
            <h2 className="font-heading text-3xl md:text-4xl text-foreground-950 mb-3">
              焦点专题
            </h2>
            <p className="text-sm md:text-base text-foreground-600 max-w-[560px] mx-auto leading-relaxed">
              深度聚焦热门话题，全方位还原事件真相
            </p>
          </div>

          {/* All items visible at once, no carousel behavior */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
            {carouselItems.map((item) => (
              <div
                key={item.id}
                className="group relative bg-foreground-950 rounded-2xl overflow-hidden cursor-pointer h-[320px] md:h-[380px]"
              >
                {/* Background image */}
                <img
                  src={item.src}
                  alt={item.title}
                  className="absolute inset-0 w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
                />
                {/* Overlay */}
                <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/40 to-black/10"></div>

                {/* Content */}
                <div className="absolute bottom-0 left-0 right-0 p-6 md:p-8">
                  <h3 className="font-heading text-2xl md:text-3xl text-background-50 mb-2 group-hover:text-accent-400 transition-colors">
                    {item.title}
                  </h3>
                  <p className="text-sm md:text-base text-background-50/80 mb-2 font-medium">
                    {item.subtitle}
                  </p>
                  <p className="text-sm text-background-50/60 leading-relaxed max-w-[480px]">
                    {item.desc}
                  </p>
                </div>

                {/* Corner accent */}
                <div className="absolute top-4 right-4 px-3 py-1 rounded-full text-xs font-medium bg-accent-500 text-background-50 whitespace-nowrap">
                  专题 #{item.id}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}